import * as _ from 'lodash';
import { useState } from 'react';
import { Flex, Button, Heading, Text, Box, Icon } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Dropdown } from '@vibe/core';
import { Status } from '@vibe/icons';
import { type ColumnSettings as ColumnSettingsType } from '@gorilla/portal-shared/src/schemas';
import { monday } from '../services/monday';

const SCOPE_OPTIONS = [
  {
    label: 'Show column in section and panel',
    value: 'overview-detail',
    endElement: {
      type: 'suffix',
      value: 'Default',
    },
  },
  {
    label: 'Show column in section only',
    value: 'overview',
  },
  {
    label: 'Show column in panel only',
    value: 'detail',
  },
];

type ColumnVisibilityModalProps = {
  show: boolean;
  column: any;
  columnSettings: ColumnSettingsType;
  onClose: (newColumnSettings?: any) => void;
};

export function ColumnVisibilityModal({ show, column, onClose, columnSettings }: ColumnVisibilityModalProps) {
  const [draft, setDraft] = useState(() => _.cloneDeep(columnSettings[column.id] || {}));
  const selectedScope = SCOPE_OPTIONS.find((opt) => opt.value === (draft?.scope || 'overview-detail')) || SCOPE_OPTIONS[0];

  return (
    <AppModal
      contentSpacing={false}
      alertDialog={true}
      width={400}
      data-testid="columnVisibilityModal"
      show={show}
      onClose={() => {
        onClose();
      }}
    >
      <AppModalContent>
        <Box marginBottom="large">
          <Flex gap={8} style={{ marginBottom: '16px' }}>
            <Icon icon={Status} size={22} style={{ transform: 'translate3d(0,-1px,0)' }} />
            <Heading type="h3" weight="bold" align="start" style={{ maxWidth: '250px' }}>
              {column.title} visibility
            </Heading>
          </Flex>

          <Flex gap={0} direction="column" align="start">
            <Box style={{ width: '100%' }}>
              <Text type="text2" style={{ marginBottom: '4px' }}>
                Visibility mode
              </Text>
              <Dropdown
                placeholder="Scope"
                size="medium"
                className="custom_dropdown"
                options={SCOPE_OPTIONS}
                value={dropdownValue(selectedScope)}
                clearable={false}
                searchable={false}
                onChange={(selectedOption: any) => {
                  setDraft((prev: any) => ({
                    ...(prev || {}),
                    scope: selectedOption.value,
                  }));
                }}
              />
            </Box>
            <Text type="text3" color="secondary" ellipsis={false} style={{ marginTop: '16px' }}>
              Control where this column is visible to clients. For example, display key information in the section and additional details in
              the panel to keep the main view clean and easy to scan.{' '}
              <a
                onClick={() => {
                  monday.execute('openLinkInTab', {
                    url: 'https://getgorilla.app/products/client-portal/docs/user-guides/item-details',
                  });
                }}
                style={{
                  cursor: 'pointer',
                }}
              >
                Learn more
              </a>
            </Text>
          </Flex>
        </Box>

        <Box marginBottom="small">
          <Flex gap={16}>
            <Button
              size="medium"
              kind="primary"
              color="primary"
              style={{ width: '100%' }}
              onClick={() => {
                onClose(draft);
              }}
            >
              Save settings
            </Button>
          </Flex>
        </Box>
      </AppModalContent>
    </AppModal>
  );
}
